import React, { createContext, useState, useContext, useEffect } from "react";
import {
  fetchAuthSession,
  fetchUserAttributes,
  signOut,
} from "aws-amplify/auth";

// Crear un contexto de autenticación
const AuthContext = createContext();

// Hook para acceder al contexto
export const useAuth = () => useContext(AuthContext);

// Proveedor del contexto de autenticación
export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null); // Estado para almacenar el rol (ADMINS, USERS, GUEST)
  const [attributes, setAttributes] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    setLoading(true);
    try {
      const session = await fetchAuthSession();
      const groups = session.tokens.idToken.payload["cognito:groups"] || [];
      const attributes = await fetchUserAttributes();
      setAttributes(attributes);
      if (groups.includes("ADMINS")) {
        setAuth("ADMINS");
      } else {
        setAuth("USERS");
      }
    } catch (error) {
      setAuth("GUEST"); // Si no hay sesión, es un visitante no autenticado
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth(); // Ejecutar la verificación de autenticación al montar el componente
  }, []);

  // Función para cerrar sesión
  const logout = async (navigate) => {
    try {
      await signOut(); // Cerrar la sesión en Amplify
      setAuth("GUEST"); // Actualizar el estado de autenticación a GUEST
      setAttributes(null); // Limpiar los atributos de usuario
      navigate("/"); // Redirigir al usuario a la página de inicio de sesión
      //window.location.reload(); // Recargar toda la aplicación para asegurarse de que todo se renderice
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <AuthContext.Provider
      value={{ auth, attributes, setAuth, logout, loading, checkAuth }}
    >
      {!loading && children}{" "}
      {/* No mostrar los hijos hasta que se haya cargado el estado */}
    </AuthContext.Provider>
  );
};
